import './style.css'

function MainHeading(props){
  return(
    <div className="user__mainheading">
      <h1>{props.heading}</h1>
    </div>
  )
}

export default MainHeading
